import { IController } from 'angular';
import { inject, injectable } from '../../../shared/utils/inject/inject';

/* @ngInject */
export function HorizontalTableController(
  $scope,
  eventsService,
  limitService,
  heightCalc,
) {
  // tslint:disable-next-line:no-invalid-this
  const vm = this;
  if ($scope.mobile) {
    vm.limit = limitService.limit;
  } else {
    vm.limit = {
      amount: 1000000,
    };
  }
  vm.result = eventsService.getResult();
  vm.even = vm.limit.amount % 2 === 0;
  vm.showMore = limitService.showMore;

  heightCalc.scrollInit();
}
